import React from "react";

const Experience = () => {
  const experiences = [
    {
      company: "DayDreamSoft LLP",
      role: "MERN Developer",
      duration: "October 2024 - Present",
      location: "Surat, Gujarat",
    },
    {
      company: "S M Techno Consultants Pvt. Ltd.",
      role: "React.js Developer",
      duration: "January 2024 - July 2024",
      location: "Surat, Gujarat",
    },
    {
      company: "Accerete Infotech",
      role: "Junior Developer",
      duration: "March 2022 - April 2022",
      location: "Surat, Gujarat",
    },
  ];

  return (
    <div className="pt-12 rounded-xl shadow-lg">
      <h2 className="text-4xl font-bold text-[#e2e8f0] mb-12 text-center relative orbitron">
        Experience
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>

      <div className="space-y-8 relative">
        {/* Timeline line */}
        <div className="absolute left-8 top-0 h-full w-0.5 bg-[#64748b]"></div>

        {experiences.map((exp, index) => (
          <div
            key={index}
            className="relative pl-16 group transition-all duration-300 hover:translate-x-2"
          >
            {/* Timeline dot */}
            <div className="absolute md:left-6 left-7 top-4 md:w-5 w-3 md:h-5 h-3 rounded-full bg-[#1e293b] border-4 border-[#64748b] group-hover:border-[#e2e8f0] transition-all duration-300 z-10"></div>

            <div className="bg-[#0f172a] p-6 rounded-lg shadow-md border-l-4 border-[#64748b] group-hover:border-[#e2e8f0] transition-all duration-300">
              <div className="space-y-4">
                <h3 className="text-2xl font-bold text-[#e2e8f0] philosopher-6">
                  {exp.company}
                </h3>

                <div className="space-y-3">
                  <p className="text-xl text-[#94a3b8] font-semibold philosopher-6">
                    {exp.role}
                  </p>

                  <div className="flex flex-wrap gap-4">
                    <div className="flex items-center text-[#94a3b8]">
                      <svg
                        className="w-5 h-5 mr-2 text-[#64748b]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <span className="philosopher-6">{exp.duration}</span>
                    </div>

                    <div className="flex items-center text-[#94a3b8]">
                      <svg
                        className="w-5 h-5 mr-2 text-[#64748b]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <span className="philosopher-6">{exp.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;